import {CommonModule} from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {svgBanco} from '@edusites/bancos-brasil-core';

import {compeToSvgBancoSlug} from '@gatewee/helpers';

export type BankSvgLogoFormat = 'square' | 'circle' | 'none';

const bankSvgLogoFormatToLibrary: Record<
  BankSvgLogoFormat,
  'quadrado' | 'circulo' | 'sem'
> = {
  square: 'quadrado',
  circle: 'circulo',
  none: 'sem',
};

/**
 * Renders `@edusites/bancos-brasil` SVG for a COMPE code when mapped; otherwise projects
 * `<ng-content>` (e.g. letter badge). SVG HTML is sanitized via DomSanitizer for trusted library output only.
 */
@Component({
  selector: 'gatewee-bank-svg-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './gatewee-bank-svg-logo.component.html',
  styleUrls: ['./gatewee-bank-svg-logo.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GateweeBankSvgLogoComponent implements OnChanges {
  @Input() compeCode: string | number | null | undefined;
  /** Maps to svgBanco `formato` (`quadrado` | `circulo` | `sem`). */
  @Input() format: BankSvgLogoFormat = 'circle';
  @Input() size = 40;

  safeSvg: SafeHtml | null = null;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly cdr: ChangeDetectorRef,
  ) {}

  ngOnChanges(): void {
    const slug = compeToSvgBancoSlug(this.compeCode);
    if (!slug) {
      this.safeSvg = null;
      this.cdr.markForCheck();
      return;
    }

    const markup = svgBanco({
      nome: slug,
      formato: bankSvgLogoFormatToLibrary[this.format],
      tamanho: this.size,
    });
    this.safeSvg = markup
      ? this.sanitizer.bypassSecurityTrustHtml(markup)
      : null;
    this.cdr.markForCheck();
  }
}
